import React, { useContext, useState } from 'react';

import Landing from '../Landing';
import { Spin, Button, Result, Typography } from 'antd';
import UserContext from '../providers/UserProvider';
import SignIn from './SignIn';

const LandingApp = (props) => {
    const context = useContext(UserContext);
    const user = context.user;
    return user.active ? (
        <Landing signOut={props.signOut} />
    ) : (
        <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page. Please contact the administrator."
            extra={
                <React.Fragment>
                    <Typography.Text type="secondary">
                        {user.email}{' '}
                    </Typography.Text>
                    <br />
                    <Button
                        type="primary"
                        onClick={props.signOut}
                        type="primary"
                    >
                        {' '}
                        Sign out
                    </Button>
                </React.Fragment>
            }
        />
    );
};

const Application = () => {
    const context = useContext(UserContext);
    const { setUser, setPending } = useContext(UserContext);
    return context.user.email ? (
        <LandingApp
            signOut={() => {
                setUser({});
                localStorage.clear();
            }}
        />
    ) : (
        <SignIn />
    );
};

export default Application;

{
    /* <Spin spinning={context.pending}>
            
</Spin> */
}



// WEBPACK FOOTER //
// ./demo/src/components/Application.js